<ng-container *ngIf="!editMode; else editForm">
  <span *ngIf="dateControlTo.value">{{ 'APP.GENERAL.DAY_AMOUNT.FULL' | translate:getTranslateParams(true) }}</span>
</ng-container>

<ng-template #editForm>
  <div class="mobile">
    <mat-form-field>
      <input matInput
             numbers
             maxlength="3"
             [id]="daysId"
             [formControl]="daysUntilControl"
             [placeholder]="placeholder | translate">
    </mat-form-field>
    <p>{{ 'APP.GENERAL.DAY_AMOUNT' | translate:getTranslateParams() }}</p>

    <mat-icon svgIcon="link"></mat-icon>

    <ng-content select="mat-form-field"></ng-content>
  </div>
</ng-template>
